module.exports = __webpack_public_path__ + "static/media/old-man-cafe-preview.721f23f0.png";